export default __webpack_public_path__ + "static/media/norway_flag.adcad43f.png";